import { Button } from '@vivaahealth/design-system';

import * as api from '../../api';
import * as store from '../../reducers/store';
import * as logger from '../../logger';

import { useSelector } from 'react-redux';
import styles from './index.module.css';
import { FormEvent, useEffect, useState } from 'react';
import { InfoMessage } from '../../components/InfoMessage';
import classNames from 'classnames';

const CAPTCHA_SITE_KEY =
  process.env.NODE_ENV === 'production'
    ? '6LdnPSQkAAAAAIIzm-1QErTgGKg4yeHztCGN1hH2'
    : '';

export function Captcha() {
  const onCaptchaSuccess = useSelector(
    (store: store.All) => store.onCaptchaSuccess,
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  const handleOnSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const captchaToken = grecaptcha.getResponse();
    try {
      await api.client.Captcha.verify(captchaToken);
      onCaptchaSuccess && onCaptchaSuccess();
    } catch (e) {
      logger.error(e);
      grecaptcha.reset();
      setErrorMessage('Please try again.');
    }
  };

  useEffect(() => {
    if (!onCaptchaSuccess) return;
    if (isScriptLoaded) return;
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    document.body.appendChild(script);
    setIsScriptLoaded(true);
  }, [onCaptchaSuccess, setIsScriptLoaded, isScriptLoaded]);

  useEffect(() => {
    if (onCaptchaSuccess) return;
    setIsScriptLoaded(false);
  }, [onCaptchaSuccess, setIsScriptLoaded]);

  if (!onCaptchaSuccess) {
    return <></>;
  }

  return (
    <div className={styles.CaptchaContainer}>
      {errorMessage && <InfoMessage isError={true}>{errorMessage}</InfoMessage>}
      <form
        className={styles.CaptchaForm}
        method="POST"
        onSubmit={handleOnSubmit}
      >
        <div
          className={classNames('g-recaptcha', styles.ReCaptcha)}
          data-sitekey={CAPTCHA_SITE_KEY}
        ></div>
        <br />
        <Button type="submit">Submit</Button>
      </form>
    </div>
  );
}
